import { environment } from "../../environments/environment";

export class NexusMap {

    public static crearMarker(latLng: google.maps.LatLng, map: google.maps.Map,title?: string, urlIcon?: string, flagNoEditable? : number) {
        let flagNoEditableMarker = flagNoEditable == 1 ? false : true
        let icon = {
            url: urlIcon,//,
            scaledSize: environment.MARKERS.ORIGEN.ICON_SIZE,//new google.maps.Size(30, 48)
        };


        let marker = new google.maps.Marker({
            position: latLng,
            // title: title,
            map: map,
            draggable: flagNoEditableMarker,
            icon: icon
        });
        return marker;

    }

    public static crearMarkerOrigen(latLng: google.maps.LatLng, map: google.maps.Map, draggable: boolean = true) {

        let icon = {
            url: environment.MARKERS.ORIGEN.URL,//,
            scaledSize:  environment.MARKERS.DESTINO.ICON_SIZE, //new google.maps.Size(45, 48)
        };


        let marker = new google.maps.Marker({
            position: latLng,
            // title: title,
            map: map,
            draggable: draggable,
            icon: icon
        });

        return marker;

    }

    public static crearMarkerConductor(latLng: google.maps.LatLng, map: google.maps.Map, draggable: boolean = true) {

        let icon = {
            url: environment.MARKERS.CONDUCTOR.URL,//,
            scaledSize:  environment.MARKERS.DESTINO.ICON_SIZE, //new google.maps.Size(45, 48)
        };


        let marker = new google.maps.Marker({
            position: latLng,
            // title: title,
            map: map,
            draggable: draggable,
            icon: icon
        });
        return marker;

    }

    public static crearMarkerDestino(latLng: google.maps.LatLng, map: google.maps.Map, draggable: boolean = true) {

        let icon = {
            url: environment.MARKERS.DESTINO.URL,//,
            scaledSize:  environment.MARKERS.DESTINO.ICON_SIZE, //new google.maps.Size(45, 48)
        };


        let marker = new google.maps.Marker({
            position: latLng,
            // title: title,
            map: map,
            draggable: draggable,
            icon: icon
        });
        return marker;
    }

    public static markerCustom(latLng: google.maps.LatLng, map: google.maps.Map,
        title?: string, urlIcon?: string) {

        let icon = {
            url: urlIcon,//,
            scaledSize: environment.MARKERS.DESTINO.ICON_SIZE
        };


        let marker = new google.maps.Marker({
            position: latLng,
            // title: title,
            map: map,
            draggable: true,
            icon: icon
        });

        return marker;
    }
}
